import fileApi from '@/api/file'

const state = {
  search: {
    pageSize: 12,
    text: '',
    loading: false,
    selected: [],
    result: {
      totalCount: 0,
      list: [],
      page: 0
    }
  }
}

const getters = {
  search (state) {
    return state.search
  }
}

const mutations = {
  SET_IMAGE_DRAWER_VISIBLE (state, visible) {
    state.imageDrawerVisible = visible
  },
  SET_SEARCH_TEXT (state, text) {
    state.search.text = text
  },
  SET_SEARCH_LOADING (state, loading) {
    state.search.loading = loading
  },
  SET_SEARCH_RESULT (state, result) {
    state.search.result = result
  },
  SET_SEARCH_SELECTED (state, selected) {
    state.search.selected = selected
  },
  ADD_UPLOAD_IMAGE (state, image) {
    state.search.result.list.unshift(image)
    state.search.result.totalCount += 1
  }
}

const actions = {
  async uploadImage ({ commit, dispatch }, formData) {
    const uploadResult = await fileApi.uploadImage(formData)
    commit('ADD_UPLOAD_IMAGE', uploadResult.file)
  },
  async searchImages ({ commit, dispatch, state }, { page }) {
    commit('SET_SEARCH_LOADING', true)
    commit('SET_SEARCH_SELECTED', [])
    try {
      const result = await fileApi.searchImages({
        fuzzy: state.search.text,
        page,
        pageSize: state.search.pageSize
      })
      commit('SET_SEARCH_RESULT', result)
    } finally {
      commit('SET_SEARCH_LOADING', false)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
